/** A partial market population must never masquerade as a valid empty/thin pool. */
export async function completeCollection(fetchPage, { batchSize = 500, maxRows = 50000, maxPages = 100 } = {}) {
  const rows = []
  const ids = new Set()
  let total = null
  for (let page = 1; page <= maxPages; page++) {
    const result = await fetchPage({ page, perPage: batchSize })
    if (!Array.isArray(result?.items) || !Number.isInteger(result.totalItems) || result.totalItems < 0) {
      throw new Error('Market response has no verifiable population count')
    }
    if (result.totalItems > maxRows) throw new Error('Market population exceeds the complete-fetch limit')
    if (total !== null && total !== result.totalItems) throw new Error('Market population changed during loading; retry')
    total = result.totalItems
    for (const row of result.items) {
      if (!row.id || ids.has(row.id)) throw new Error('Market response contains missing or repeated record identities')
      ids.add(row.id)
      rows.push(row)
    }
    if (rows.length > total) throw new Error('Market response exceeds its declared population')
    if (rows.length === total) return rows
    if (!result.items.length) throw new Error('Market response ended before the complete population arrived')
    // A server may clamp perPage below the requested size. Count, not page length,
    // establishes completeness; a short page alone must not truncate the market.
  }
  throw new Error('Market population exceeds the complete-page limit')
}
